import { useContext } from 'react';

import { GeneralDispatchContext, GeneralStateContext } from './contexts';

export const useGeneralDispatch = () =>
  useContext(GeneralDispatchContext);

export const useGeneralState = () =>
  useContext(GeneralStateContext);
